import { render, staticRenderFns } from "./AdjustForm.vue?vue&type=template&id=25a65182"
import script from "./AdjustForm.vue?vue&type=script&lang=js"
export * from "./AdjustForm.vue?vue&type=script&lang=js"
import style0 from "./AdjustForm.vue?vue&type=style&index=0&id=25a65182&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports